import { graphql } from '@prophecy/graphql-types/graphql';
export const getOnBoardingDetailsReplayQuery = graphql(`
  query professionalOnboardingDetails {
    professionalOnboardingDetails {
      industry
      projectId
      replay {
        uid
        replayId
        shareLink
      }
    }
  }
`);
export const getProjectReplaysQuery = graphql(`
  query getProjectReplays($projectUID: String!) {
    getProjectReplays(projectUID: $projectUID) {
      uid
      name
      description
      replayId
      projectUID
      createdAt
      createdBy
      sharedUserUID
      fabricUID
      pipelineName
      appNames
      replayJson
      shareLink
    }
  }
`);
